import store from '../store/store';
import { action } from 'satcheljs/lib/legacy';
import SweepRuleRequestStatus from '../store/schema/SweepRuleRequestStatus';

/**
 * Set the SweepRuleRequestStatus in the sweep rules options store
 * @param requestStatus the get sweep rules request status to set
 */
export default action('setSweepRuleRequestStatus')(function setSweepRuleRequestStatus(
    requestStatus: SweepRuleRequestStatus
) {
    store.getSweepRulesRequestStatus = requestStatus;
});
